import { AvailableTemplatesComponent } from "./available-templates/available-templates.component";
import { CreateCampaignsComponent } from "./create-campaigns/create-campaigns.component";
import { CampaignAddEmployeeComponent } from "./directives/campaign-add-employee/campaign-add-employee.component";
import { CampaignAddRouteComponent } from "./directives/campaign-add-route/campaign-add-route.component";
import { EditCampaignsComponent } from "./edit-campaigns/edit-campaigns.component";
import { ListCampaignsComponent } from "./list-campaigns/list-campaigns.component";

export const CampaignsDeclarion = [
    CreateCampaignsComponent,
    EditCampaignsComponent,
    ListCampaignsComponent,
    AvailableTemplatesComponent,
    CampaignAddEmployeeComponent,
    CampaignAddRouteComponent,
]